var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgStudy(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 58,
    height: 73,
    viewBox: "0 0 58 73",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M54.75 0H2.60714C1.16507 0 0 1.16507 0 2.60714V70.3929C0 71.8349 1.16507 73 2.60714 73H54.75C56.1921 73 57.3571 71.8349 57.3571 70.3929V2.60714C57.3571 1.16507 56.1921 0 54.75 0ZM33.567 5.86607H41.3884V22.9673L37.5999 20.2054L33.567 23.0895V5.86607ZM51.4911 67.1339H5.86607V5.86607H28.6786V30.0555C28.6786 30.3243 28.76 30.5932 28.923 30.8132C29.0219 30.953 29.1476 31.0718 29.2927 31.1628C29.4378 31.2537 29.5996 31.315 29.7685 31.343C29.9375 31.371 30.1103 31.3653 30.2771 31.3261C30.4438 31.2869 30.6011 31.215 30.7398 31.1146L37.5673 26.2344L44.1992 31.0739C44.4192 31.2368 44.6881 31.3265 44.9651 31.3265C45.682 31.3265 46.2686 30.7398 46.2686 30.0229V5.86607H51.4829V67.1339H51.4911Z",
    fill: "#92CDDC"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStudy);
export default __webpack_public_path__ + "static/media/study.41cf838c833472a01658e9c1bddc4a8d.svg";
export { ForwardRef as ReactComponent };